import axios from "axios"
import { apiRoutes } from "../utils/routes"
import { AppUtil } from "../utils/app.utils"

const {  getCommonAPIConfig} = AppUtil

export const getSampleNames = async ({sampleDate,sampleName}:{sampleDate?: string, sampleName?: string}) => {
    const response = await axios.post(
      apiRoutes.qiagenManager.get,
      {
        sampleDate: sampleDate,
        sampleName: sampleName
      },
      getCommonAPIConfig()
    )
  
    return response
  }